import script from "./BookingHome.vue?vue&type=script&setup=true&lang=js"
export * from "./BookingHome.vue?vue&type=script&setup=true&lang=js"

import "./BookingHome.vue?vue&type=style&index=0&id=6895c696&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6895c696"]])

export default __exports__